/* eslint-disable react/prefer-stateless-function */
import { h, Component } from 'preact';
import style from './style';
import { getPageConfig } from '../../../lib/device';
import cx from 'classnames';
import { getCommonProps } from '../../../lib/page';
import CategoryClusterP25 from '../category-cluster-p25';
import { trackingProvider, DIMENSION, trackProps } from '@cube/track';
import dlv from 'dlv';
import {
	fetchFirestoreDocument,
	fetchTitle,
	parseFirestoreMap
} from '../../../lib/dailymotion';
@trackingProvider({
	[DIMENSION.componentpath]: 'NewsClusterP25'
})
export default class NewsClusterP25 extends Component {
	getTitles = (props) =>
		fetchTitle(
			props.title.feed,
			this.props.streamClient,
			this.props.startContentServiceOrigin
		)
			.then((results) => dlv(results, 'cards.0.title') || null)
			.catch((err) => {
				console.error('Error fetching title:', err);
				return null;
			});

	getFinalNewsTabs = () => {
		let finalTabs = this.props?.pageConfig?.clusters?.newsTabs || [];
		if (this.props.firebaseConfig){
			fetchFirestoreDocument(this.props.firebaseConfig)
				.then((data) => {
					const values = data?.fields?.newsTabs?.arrayValue?.values;
					if (!values) return;

					const firebaseCustomTabs = values.map((item) =>
						parseFirestoreMap(item.mapValue.fields)
					);

					const promises = firebaseCustomTabs.map((tab, i) => {
						if (!tab?.isEnabled) return Promise.resolve(null);

						return this.getTitles(tab).then((title) => {
							if (!title) return null;

							return {
								label: title,
								qeId: 'sc-home-entertainment-' + title,
								width: this.props.width,
								tabContent: {
									feed: tab.content.feed,
									title,
									linksfeed: tab.links,
									taboolaNewsroomTag: tab?.taboolaNewsroomTag,
									link: {
										url: `/special/title/${title}?specialId=${i}&title=${encodeURIComponent(
											title
										)}`,
										label: `Browse ${title}`
									}
								},
								id: tab.id || `firebase-tab-${i}`
							};
						});
					});

					Promise.all(promises).then((resolvedTabs) => {
						const tabs = resolvedTabs.filter(Boolean);
						finalTabs = [...tabs, ...finalTabs];
						this.setState({ customTabs: finalTabs });
						this.setActiveTab(finalTabs[0]?.id);
					}).catch((error) => {
						console.error('Error resolving tabs:', error);
					});
				})
				.catch((error) => {
					console.error('Error in getFinalNewsTabs:', error);
				});
		}
	};

	setActiveTab = (tabId) => {
		this.setState({ activeTab: tabId });
	};
	componentWillMount() {
		this.setActiveTab(this.props?.pageConfig?.clusters?.newsTabs[0]?.id);
		let pageConfig = getPageConfig(this.props?.pageConfig, 'Desktop');
		this.getFinalNewsTabs();
		this.setState({ pageConfig });
	}

	componentDidMount() {}

	render({ width, ...props }, { customTabs, activeTab }) {
		const tabs = customTabs || props?.pageConfig?.clusters?.newsTabs;
		return (
			<div class={style.newsCluster}>
				<div class={style.tabsContainer}>
					<div class={cx(style.tabs, style.tabStyleFlip)}>
						<nav>
							<ul>
								{tabs?.map((tab, i) => (
									<li
										key={tab?.id}
										// eslint-disable-next-line react/jsx-no-bind
										onClick={() => this.setActiveTab(tab?.id)}
										class={tab.id === activeTab ? style.tabCurrent : ''}
									>
										<a
											{...trackProps(
												{
													[DIMENSION.contenttitle]: 'Tab-' + tab?.label,
													[DIMENSION.clickindex]: i + 1
												},
												this.context
											)}
										>
											{tab.label}
										</a>
									</li>
								))}
							</ul>
						</nav>
						<div class={style.contentWrap}>
							{tabs?.map(
								(tab) =>
									tab.id === activeTab && (
										<section
											key={tab?.id}
											// eslint-disable-next-line react/jsx-no-bind
											onClick={() => this.setActiveTab(tab?.id)}
										>
											<CategoryClusterP25
												{...tab?.tabContent}
												title={tab?.label}
												category={tab?.category || tab?.label}
												qeId={'sc-home-entertainment-' + tab.label}
												width={width}
												{...getCommonProps(props)}
											/>
										</section>
									)
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
